import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { BaseComponent } from '../../base/base-component.directive';
import {
  FieldType,
  FilterField,
  FilterFieldOption,
} from '../../dialogs/grid-filters/grid-filters.component';
import * as moment from 'moment';

@Component({
  standalone: false,
  selector: 'app-filter-chimp-text',
  templateUrl: './filter-chimp-text.component.html',
  styleUrls: ['./filter-chimp-text.component.scss'],
})
export class FilterChimpTextComponent extends BaseComponent implements OnInit {
  @Input() key?: string;
  @Input() value: unknown;
  @Input() field?: FilterField;

  fieldValue?: string;

  constructor(private changeDetector: ChangeDetectorRef) {
    super();
  }

  get fieldText() {
    return this.field?.text;
  }

  ngOnInit(): void {
    switch (this.field?.type) {
      case FieldType.AUTOCOMPLETE:
        this.field.options!
          .pipe(
            map(
              (items: FilterFieldOption[]) =>
                items.find((item) => item.id === this.value)?.description
            )
          )
          .pipe(tap((item) => (this.fieldValue = item)))
          .pipe(tap(() => this.changeDetector.detectChanges()))
          .pipe(this.autoDispose())
          .subscribe();
        break;
      case FieldType.AUTOCOMPLETE_ARRAY:
        this.field.options!
          .pipe(
            map((items: FilterFieldOption[]) => {
              const val: number[] = this.value as number[];

              const descriptions = val
                .map(id => items.find(item => item.id === id)?.description)
                .filter(desc => !!desc); 

              return descriptions.join(' ');
            }),
            tap(result => this.fieldValue = result),
            tap(() => this.changeDetector.detectChanges()),
            this.autoDispose()
          )
          .subscribe();
          break;
      case FieldType.GRAFANA_AUTOCOMPLETE:
        this.field.options!
          .pipe(
            map(
              (items: FilterFieldOption[]) =>
                items.find((item) => item.description === this.value)?.description
            )
          )
          .pipe(tap((item) => (this.fieldValue = item)))
          .pipe(tap(() => this.changeDetector.detectChanges()))
          .pipe(this.autoDispose())
          .subscribe();
        break;
      case FieldType.GRAFANA_DATERANGE:
        const first = new Date(0)
        const second = new Date(0)
        const start=moment(first.setUTCMilliseconds(Number(String(this.value).split(',')[0]))).format('yyyy-MM-DD')
        const end=moment(second.setUTCMilliseconds(Number(String(this.value).split(',')[1]))).format('yyyy-MM-DD')
        this.fieldValue=`${start},${end}`;
        break;
      case FieldType.BOOLEAN:
        if(this.value === 'True'){
          this.fieldValue = '\u2705';
        } else if(this.value === 'False'){
          this.fieldValue = '\u274C';
        } else {
          this.fieldValue = this.value ?  '\u2705' : '\u274C'; 
        }
        break;

      default:
        this.fieldValue = `${this.value}`;
    }
  }
}
